










import { Vue, Component, Prop } from "vue-property-decorator";

export interface TableOfContentsModel {
    id: string;
    title: string;
}

@Component
export default class TableOfContents extends Vue {
    @Prop({required: true}) stages: TableOfContentsModel[];

    scrollToStage(id: string) {
        const element = document.getElementById(id);
        element?.scrollIntoView({ behavior: "smooth" });
    }
}
